export const getPlayerPreviewState = (open?: boolean) => {
  return open ? 'open' : 'closed';
};
